export enum INNER_EVENT {
  // Room 相关事件 1 - 20
  ROOM_DESTROY = '1',
  // 进房相关 21 - 50
  JOIN_START = '21',
  JOIN_SCHEDULE_SUCCESS = '22',
  JOIN_SIGNAL_CONNECTION_START = '23',
  JOIN_SIGNAL_CONNECTION_END = '24',
  JOIN_SEND_CMD = '25',
  JOIN_RECEIVED_CMD_RES = '26',
  JOIN_SUCCESS = '27',
  JOIN_FAILED = '28',
  WHIP_REQUEST_COST = '29',
  WHIP_PULL_RESULT = '30',
  // 退房相关 51 - 60
  LEAVE_START = '51',
  LEAVE_SEND_CMD = '52',
  LEAVE_SUCCESS = '53',
  // 推流相关 61 - 80
  PUBLISH_START = '61',
  SEND_FIRST_VIDEO_FRAME = '62',
  PUBLISH_FAILED = '63',
  // 订阅相关 81 - 100
  SUBSCRIBE_START = '81',
  SUBSCRIBE_SUCCESS = '82',
  SUBSCRIBE_FAILED = '84',
  UNSUBSCRIBE_SUCCESS = '83',
  // Track 相关 101 - 150
  LOCAL_TRACK_CAPTURE_START = '101',
  LOCAL_TRACK_CAPTURE_SUCCESS = '102',
  LOCAL_TRACK_CAPTURE_FAILED = '103',
  LOCAL_TRACK_PUBLISHED = '104',
  LOCAL_TRACK_UNPUBLISHED = '105',
  LOCAL_TRACK_REPLACED = '106',
  SWITCH_DEVICE_SUCCESS = '107',
  TRACK_MUTED = '108',
  TRACK_UNMUTED = '109',
  REMOTE_TRACK_SUBSCRIBED = '110',
  REMOTE_TRACK_UNSUBSCRIBED = '111',
  LOCAL_TRACK_RECAPTURE = '112',
  LOCAL_AUDIO_STARTED = '113',
  LOCAL_AUDIO_STOPPED = '114',
  REMOTE_AUDIO_STARTED = '115',
  REMOTE_AUDIO_STOPPED = '116',
  LOCAL_TRACK_STOPPED = '117',
  LOCAL_VIDEO_TRACK_PREPROCESSED = '118',

  // 播放相关 151 - 200
  PLAY_TRACK_START = '151',
  PLAYER_STATE_CHANGED = '152',
  VIDEO_LOADED_DATA = '153',
  AUTOPLAY_DIALOG_CLICK_CONFIRM = '154',
  AUDIO_CONTEXT_LONG_SUSPENDED = '155',
  REMOTE_VIDEO_PLAY_START = '156',
  REMOTE_VIDEO_PLAY_FINISH = '157',
  // 连接相关 201 - 250
  // WebRTC 事件，WASM 无需处理
  SIGNAL_CONNECTION_STATE_CHANGED = '201',
  PEER_CONNECTION_STATE_CHANGED = '202',
  SINGLE_CONNECTION_STAT = '203',
  SPC_RECONNECTED = '204',

  // 其他 251 - 300
  HEARTBEAT_REPORT = '251',
  RECEIVED_PUBLISHED_USER_LIST = '252',
  REMOTE_PUBLISH_STATE_CHANGED = '253',
  AUDIO_LEVEL_INTERVAL = '260',
  NETWORK_QUALITY = '261',
  VIDEO_CODEC_IMPLEMENTATION_CHANGED = '262',
  QUALITY_LIMITATION_CHANGED = '263',
  LOG = '264',
  AUDIO_PROCESSOR_DEBUG = '265',
  SSO_SWITCH = '266',
  SEI_MESSAGE = '267',
  USER_PAUSE_IN_PIP = '268',
  USER_RESUME_IN_PIP = '269',
  ENTER_PICTURE_IN_PICTURE = '270',
  LEAVE_PICTURE_IN_PICTURE = '271',

  // 背景音 301 - 400

  // 切换房间 401 - 430
  SWITCH_ROOM_START = '401',
  SWITCH_ROOM_SUCCESS = '407',
  SWITCH_ROOM_FAILED = '408'
}
